<template>
  <div>
    <Header></Header>
    <div class="container">
      <el-container style="border: 1px solid #eee;">
        <el-aside width="200px" style="background-color: rgb(238, 241, 246);">
          <el-row class="tac">
            <el-col>
              <h5>{{ cname }}教程</h5>
              <el-menu default-active="0" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
                <el-menu-item :index="index.toString()" v-for="(item, index) in articleList" :key="item.id"
                  @click="getDetail(item.id)">
                  <span slot="title">{{ item.title }}</span>
                </el-menu-item>
              </el-menu>
            </el-col>
          </el-row>
        </el-aside>
        <el-container>
          <el-main>
            <div class="articlelist">
              <ArticleContent :id="articleId" ref="articleContentChild"></ArticleContent>
            </div>
          </el-main>
        </el-container>
      </el-container>
      <!-- <el-pagination
        background
        layout="prev, pager, next"
        :total="totalNum"
        :page-size="15"
        @current-change="handleCurrentChange"
      >
      </el-pagination> -->

    </div>
    <!-- <el-backtop target=".container"></el-backtop> -->
  </div>
</template>
<style>
.el-menu {
  background-color: rgb(238, 241, 246) !important;
}
</style>
<style scoped>
h4 {
  padding: 0px;
  margin: 0px;
  padding-bottom: 6px;
}

.articlelist {
  text-align: left;
  margin: 0 auto;
  margin-bottom: 16px;
}

.left {
  float: left;
}

.right {
  float: right;
}

.title {
  position: relative;
}

.close-btn {
  padding-top: 4px;
}

.desc {
  font-size: 14px;
  color: #8a8a8a;
  width: 80%;
}

.online {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.views {
  line-height: 23px;
  padding-top: 6px;
}

.views>i {
  padding-left: 8px;
}
</style>
<script>
import "../assets/css/common.css";
import Header from "../components/headernew.vue";
import ArticleContent from '../component-slice/article_content.vue';
// import Footer from "./footer";
export default {
  components: {
    Header,
    ArticleContent
  },
  data() {
    return {
      totalNum: 0,
      articleList: [],
      pageIndex: 1,
      techId: 0,
      articleId: 0,
      cname: ""
    };
  },
  created() {
    this.cname = this.$route.query.name;
    var techId = this.$route.params.id;
    if (techId != null && techId != undefined) {
      this.techId = techId;
    }
  },
  mounted() {
    this.getTotalNum();
    this.getList(1);
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getTotalNum() {
      this.$http
        .get("/api/articleview/count/" + this.techId)
        .then((r) => {
          this.totalNum = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getDetail(id) {
      this.articleId = id;
      console.log(this.articleId)
      this.$refs.articleContentChild.getArticle(this.articleId)
    },
    getList(pageIndex) {
      this.pageIndex = pageIndex;
      this.$http
        .get("/api/articleview2/list/" + this.techId)
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.articleList = r.data.data;
            if (this.articleList.length > 0) {
              this.articleId = this.articleList[0].id;
              this.$refs.articleContentChild.getArticle(this.articleId)
            }
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleCurrentChange(pageIndex) {
      this.getList(pageIndex);
    },
  },
};
</script>
